import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledMenuContentComponent } from "./menu-content-component.scss";
import onClickOutside from "react-onclickoutside";
class MenuContentComponent extends PureComponent {
    handleClickOutside() {
        const { closeMenu } = this.props;
        if (closeMenu) closeMenu();
    }
    render() {
        const { style } = this.props;
        return /*#__PURE__*/ _jsx(StyledMenuContentComponent, {
            className: "menu-content-component",
            style: style,
            children: this.props.contentRenderer()
        });
    }
    constructor(props){
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
}
export default onClickOutside(MenuContentComponent);
